import React from 'react';

const Nebraska = () => {
  return (
    <div>
      
    </div>
  );
}

export default Nebraska;
